/* eslint-disable import/no-named-as-default-member */
import _ from "lodash";
import styled from "styled-components";
import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Dialog, DialogActions, DialogTitle, DialogContent, Grid, IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import moment from "moment";
import LoanStep from "./Step";
import { getLoansByPreferenceAndLoanStatus } from './changeDealStatusModal.store';
import { modifyLoans } from "../../store/state/deal";
import loanStatuses from "../../constants/loanStatuses";
import numberFormatter from "../../utils/numberFormatter";
import { PrimaryButton, SecondaryButton, ButtonSizeOptions } from "@loanbossinc/component-library";

const getInterestRateType = loan => {
  return _.get(loan, "rateTypeRef.name") || "N/A";
};

const getLoanAmount = loan => {
  return numberFormatter.maskCurrency(loan.amount) || "N/A";
};

const formatForDisplay = loan => {
  return {
    ...loan,
    title: `${loan["lenderCompany.name"] || _.get(loan, "loanCompanyBridge[0].company.name") || "N/A"} | ${
      loan.maturityDate ? moment(loan.maturityDate).format("MM/DD/YYYY") : "N/A"
    } | ${getInterestRateType(loan)} | ${getLoanAmount(loan)}`
  };
};

const isNotGhostLoan = loan => (loan["lenderCompany.name"] || _.get(loan, "loanCompanyBridge[0].company.name")) && loan.loanStatusId && loan.loanSeniorityId;

const StepInstructions = styled.div`
  color: rgba(0, 0, 0, 0.537254901960784);
`;

class ModifyLoansModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLoanIds: []
    };
  }

  componentDidMount() {
    this.props.getLoansByPreferenceAndLoanStatus({
      dealId: this.props.dealId,
      loanStatusId: loanStatuses.CLOSED_LOAN,
      page: 0,
      pageSize: Number.MAX_VALUE,
      includePassedRejected: false,
      subKey: "closedLoans"
    });
  }

  onToggle = id => {
    const selectedLoanIds = this.state.selectedLoanIds;
    const selectedLoanIdsCopy = [...selectedLoanIds];
    const index = _.findIndex(selectedLoanIds, x => x === id);

    if (index === -1) {
      selectedLoanIdsCopy.push(id);
    } else {
      selectedLoanIdsCopy.splice(index, 1);
    }
    this.setState({ selectedLoanIds: selectedLoanIdsCopy });
  };

  modifyLoans = () => {
    if (this.state.selectedLoanIds.length !== 0) {
      this.props.modifyLoans(this.props.dealId, this.state.selectedLoanIds);
      this.props.onClose();
    }
  };

  render() {
    if (!this.props.closedLoans) {
      return null;
    }

    const { isOpen, handleClose, closedLoans } = this.props;
    return (
      <>
        <Dialog open={isOpen === undefined ? true : isOpen} onClose={this.props.onClose} fullWidth maxWidth="md">
          <Grid container direction="row" alignItems="center" justify="space-between">
            <DialogTitle>Modify Loans</DialogTitle>
            <IconButton style={{ marginRight: 16 }} onClick={this.props.onClose}>
              <Close style={{ fontSize: 36 }} />
            </IconButton>
          </Grid>
          <DialogContent>
            <StepInstructions>Choose the loan(s) you would like to modify:</StepInstructions>
            <LoanStep loans={this.props.closedLoans} selectedLoanIds={this.state.selectedLoanIds} onToggle={this.onToggle} />
          </DialogContent>
          <DialogActions>
            <SecondaryButton
              style={{ marginLeft: 'auto' }}
              label="CANCEL"
              onClick={this.props.onClose}
              size={ButtonSizeOptions.smFluid}
              />
            <PrimaryButton 
              label="MODIFY LOAN(S)"
              size={ButtonSizeOptions.smFluid}
              onClick={this.modifyLoans}
              style={{ marginLeft: '16px' }}/>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

const mapStateToProps = ({ changeDealStatusModal }) => {
  return {
    closedLoans: changeDealStatusModal.loansByStatus[loanStatuses.CLOSED_LOAN] ? changeDealStatusModal.loansByStatus[loanStatuses.CLOSED_LOAN].loans.filter(isNotGhostLoan).map(formatForDisplay) : null
  };
};

export default compose(connect(mapStateToProps, { getLoansByPreferenceAndLoanStatus, modifyLoans }))(ModifyLoansModal);
